import { render, staticRenderFns } from "./M2hDashboard.vue?vue&type=template&id=63fdb7c8&scoped=true&"
import script from "./M2hDashboard.vue?vue&type=script&lang=js&"
export * from "./M2hDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fdb7c8",
  null
  
)

export default component.exports